/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowAUpLeftIcon16Light } from './ArrowAUpLeftIcon16Light';
import { ArrowAUpLeftIcon16Regular } from './ArrowAUpLeftIcon16Regular';
import { ArrowAUpLeftIcon16Solid } from './ArrowAUpLeftIcon16Solid';
import { ArrowAUpLeftIcon20Light } from './ArrowAUpLeftIcon20Light';
import { ArrowAUpLeftIcon20Regular } from './ArrowAUpLeftIcon20Regular';
import { ArrowAUpLeftIcon20Solid } from './ArrowAUpLeftIcon20Solid';
import { ArrowAUpLeftIcon24Regular } from './ArrowAUpLeftIcon24Regular';
import { ArrowAUpLeftIcon24Solid } from './ArrowAUpLeftIcon24Solid';
import { ArrowAUpLeftIcon32Regular } from './ArrowAUpLeftIcon32Regular';
import { ArrowAUpLeftIcon64Regular } from './ArrowAUpLeftIcon64Regular';
var sizes = {
    16: {
        light: ArrowAUpLeftIcon16Light,
        regular: ArrowAUpLeftIcon16Regular,
        solid: ArrowAUpLeftIcon16Solid,
    },
    20: {
        light: ArrowAUpLeftIcon20Light,
        regular: ArrowAUpLeftIcon20Regular,
        solid: ArrowAUpLeftIcon20Solid,
    },
    24: {
        regular: ArrowAUpLeftIcon24Regular,
        solid: ArrowAUpLeftIcon24Solid,
    },
    32: {
        regular: ArrowAUpLeftIcon32Regular,
    },
    64: {
        regular: ArrowAUpLeftIcon64Regular,
    },
};
export var ArrowAUpLeftIcon = forwardRef('ArrowAUpLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
